import { motion, AnimatePresence } from 'framer-motion';
import clsx from 'clsx';

type Props = {
  state: 'idle' | 'recording' | 'stopping' | 'busy';
  onStart: () => void;
  onStop: () => void;
  className?: string;
};

export function MicButton({ state, onStart, onStop, className }: Props) {
  const live = state === 'recording';
  return (
    <button
      type="button"
      onClick={() => (live ? onStop() : onStart())}
      disabled={state === 'stopping' || state === 'busy'}
      className={clsx(
        'relative grid place-items-center size-12 rounded-full transition focus-ring',
        live ? 'bg-danger text-white shadow-glow' : 'glass-strong text-ink-1 hover:bg-white/[0.1]',
        state === 'busy' && 'opacity-60',
        className,
      )}
      aria-label={live ? 'Остановить запись' : 'Записать голос'}
    >
      <AnimatePresence>
        {live && (
          <motion.span
            key="pulse"
            initial={{ scale: 1, opacity: 0.6 }}
            animate={{ scale: 1.5, opacity: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.4, repeat: Infinity, ease: 'easeOut' }}
            className="absolute inset-0 rounded-full bg-danger"
            aria-hidden
          />
        )}
      </AnimatePresence>
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        className="relative"
      >
        <rect x="9" y="3" width="6" height="12" rx="3" stroke="currentColor" strokeWidth="1.8" />
        <path
          d="M5 11a7 7 0 0 0 14 0M12 18v3"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}
